/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import { useEffect } from 'react';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useMutation,
} from 'react-apollo';

import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';
import { isUnauthorizedError } from '@confluence/error-boundary/entry-points/isUnauthorizedError.ts';

import type { useCreateInvitationUrlCreateInvitationMutation as useCreateInvitationUrlCreateInvitationMutation$data } from './__types__/useCreateInvitationUrlCreateInvitationMutation.ts';

export const useCreateInvitationUrl = () => {
	const [createNewInviteLink, { data, loading, error, called }] =
		useMutation<useCreateInvitationUrlCreateInvitationMutation$data>(gql`
			mutation useCreateInvitationUrlCreateInvitationMutation {
				createInvitationUrl {
					id
					url
				}
			}
		`);

	useEffect(() => {
		if (error) {
			if (isUnauthorizedError(error)) {
				markErrorAsHandled(error);
			}
		}
	}, [error]);

	const newInviteLink = data?.createInvitationUrl?.url;

	return {
		createNewInviteLink,
		newInviteLink,
		called,
		loading,
		error,
	};
};
